import createPage from "@src/components/page"
import React from "react"
import logoJson from "@images/lottieJson/2021.json"
import circleJson from "@images/lottieJson/circle.json"
import LottieControl from "@src/components/lottie"
import * as styles from "./pageWelcome.module.scss"
import tagImg from "@images/png/1.png"
import heImg from "@images/png/2.png"
import { useEnteringTrail, callYou } from "@src/components/page/lib"
import { animated } from "react-spring"
import { redColor } from "@config"
import { useContext } from "react"
import AppContext from "@src/context/appContext"

const tip = (data, { currentUser, queryToken }) => {
  if (!data) {
    if (queryToken) {
      return "无法找到TA的年度报告"
    }
    if (currentUser) {
      return `无法找到${currentUser.attributes?.nickname}的年度报告`
    }
    return "无法找到年度报告"
  }
  return `${callYou(data)}与机核的2021`
}

const PageWelcome = createPage(
  ({ offset, data }) => {
    const { currentUser, queryToken } = useContext(AppContext)
    const anime1Styles = useEnteringTrail(2, offset)
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.4, type: "mlt" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div className={styles.container}>
          <LottieControl
            className={styles.logo}
            animationData={logoJson}
            config={{ renderer: "svg" }}
            style={anime1Styles[0]}
          />
          <LottieControl
            className={styles.circle}
            animationData={circleJson}
            config={{ renderer: "svg" }}
            style={anime1Styles[1]}
          />
          <animated.img
            className={styles.tag}
            src={tagImg}
            alt="tag"
            style={anime2Styles[0]}
          />
          <animated.img
            className={styles.he}
            src={heImg}
            alt="he"
            style={anime2Styles[1]}
          />
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          {tip(data, { currentUser, queryToken })}
          <br />
          生成数据截止于 2021 年 12 月中旬
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  },
  {
    showShare: true,
  }
)

export const pageWelcomeData = {
  key: "welcome",
  bg: redColor,
  Page: PageWelcome,
}

export default PageWelcome
